import { useEffect, useRef, useState } from 'react';

export default function useReveal() {
  const ref = useRef(null);
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const el = ref.current;
    if (!el) return;

    let done = false;
    let raf = null;

    const check = () => {
      if (done) return;
      // Don't reveal anything until the user has actually scrolled down -
      // avoids content near the fold being marked "seen" before it's really
      // been looked at (was happening via IntersectionObserver, which can
      // fire on its very first measurement even for content just past the
      // initial viewport edge).
      if (window.scrollY <= 0) return;
      const rect = el.getBoundingClientRect();
      if (rect.top < window.innerHeight * 0.88) {
        done = true;
        setVisible(true);
        window.removeEventListener('scroll', onScroll);
      }
    };

    const onScroll = () => {
      if (raf) return;
      raf = requestAnimationFrame(() => {
        raf = null;
        check();
      });
    };

    window.addEventListener('scroll', onScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', onScroll);
      if (raf) cancelAnimationFrame(raf);
    };
  }, []);

  return [ref, visible];
}
